
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c1272d","d":"M900 0H0v600h900z"}}),_c('path',{attrs:{"d":"M450 224.315l-44.467 136.87 116.401-84.559h-143.87l116.403 84.559z","fill":"none","stroke":"#006233","stroke-width":"14.63"}})])
          )
        }
      }
    